import type { LocaleDomain } from "../types";

import { getLocaleDomains } from "./get-locale-domains";

function isRegisteredLocaleDomain(value: string): value is LocaleDomain {
  for (const domain of getLocaleDomains()) {
    if (domain === value) {
      return true;
    }
  }

  return false;
}

export { isRegisteredLocaleDomain };
